import { Injectable }           from '@angular/core';
import { Http, Response }       from '@angular/http';
import { Observable }           from 'rxjs/Observable';
import { ConfigService }        from '../configuracion/config.service';
import { RequestBaseService }   from '../request-base/request-base.service';
import { JwtHttp, AuthService } from 'ng2-ui-auth';
import { FileUploader }         from 'ng2-file-upload';

import 'rxjs/add/operator/map';

@Injectable()
export class UsuarioService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
  ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'usuario'].join('/');
  }

  public getAllSF(): Observable<any> {
    return this.http.get(
      [this.ApiUrl,'sf'].join('/')).map(res => res.json());
  }

  public comprobarNavegador(): Observable<any> {
    return this.http.get(
        [this.ApiUrl, 'navegador'].join('/')).map(res => res.json());
  }

  public ChangePassword(model: any) {
    return this.http
      .post([this.ApiUrl, 'change'].join('/'), {data: model})
      .map(res => res.json());
  }

  public guardarUsuario(model: any): Observable<any> {
    let file: FileUploader = model.imagen;

    model.imagen = 'logo-inger.png';
    model.activo = 1;
    return new Observable(observer => {
      super.save(model)
        .subscribe(
          data => {
            if(file.queue.length > 0) {
              file.authToken      = this.auth.getToken();
              file.options.url    = [this.ApiUrl, data.id, 'upload'].join('/');
              file.queue[0].url   = [this.ApiUrl, data.id, 'upload'].join('/');

              file.queue[0].upload();

              file.queue[0]._xhr.onreadystatechange = function(e) {
                if(file.queue[0]._xhr.readyState == 4) {
                  data.imagen = [data.id, 'jpg'].join('.');

                  observer.next(data);
                }
              }               
            } else {
              observer.next(data);
            }
          },
          error => console.log(error)
        )
    });
  }


  public actualizarUsuarioImagen(id, model: any): Observable<any> {
    let file: FileUploader = model.imagen;

    delete model.imagen;

    return new Observable(observer => {
      super.update(id, model)
        .subscribe(
          data => {
            if(file.queue.length > 0) {
              file.authToken      = this.auth.getToken();
              file.options.url    = [this.ApiUrl, data.id, 'upload'].join('/');
              file.queue[0].url   = [this.ApiUrl, data.id, 'upload'].join('/');

              file.queue[0].upload();

              file.queue[0]._xhr.onreadystatechange = function(e) {
                if(file.queue[0]._xhr.readyState == 4) {
                  data.imagen = [data.id, 'jpg'].join('.');

                  observer.next(data);
                }
              }               
            } else {
              observer.next(data);
            }
          },
          error => console.log(error)
        )
    });
  }


  public updatePassword(id, model): Observable<any> {
    this.validate();

    return this.http
      .put([this.ApiUrl, id, 'password'].join('/'), {data: model})
      .map(res => res.json());    
  }


}



// WEBPACK FOOTER //
// ./src/app/services/usuario/usuario.service.ts